import type { BrandConfig } from './types';
import juxflowLogo from '@/assets/images/JuxFlow.png';

/**
 * JuxFlow 品牌（域名 juxflow.ame-film.com）
 * - Logo 使用独立图片资源 src/assets/images/JuxFlow.png
 * - 站点默认语种为英文
 */
export const juxflowConfig: BrandConfig = {
  key: 'juxflow',
  isDefault: false,
  subdomain: 'juxflow.ame-film.com',
  logo: juxflowLogo,
  title: 'JuxFlow: Visual AIGC Workflows & Creator Community',
  localizedTitles: {
    'en-US': 'JuxFlow: Visual AIGC Workflows & Creator Community',
    'zh-CN': 'JuxFlow: 可视化 AIGC 工作流与创作者社区',
  },
  siteName: 'JuxFlow',
  allowedCreationTabs: ['text', 'image', 'video', 'tools'],
  payment: {
    productName: 'JuxFlow Platform Paid Service Agreement',
    productNameKey: 'payment.ameProductName',
  },
  agreementTabs: [
    { key: 'user-agreement', label: 'JuxFlow Platform Payment Agreement', labelKey: 'agreement.tabAmePayment' },
    { key: 'ricegrain-rules', label: 'Credits Rules', labelKey: 'agreement.tabRiceGrain' },
    { key: 'privacy-policy', label: 'User Agreement', labelKey: 'agreement.tabUserAgreement' },
    { key: 'privacy-policy-detail', label: 'Privacy Policy', labelKey: 'agreement.tabPrivacyDetail' },
    { key: 'enterprise-service-agreement', label: 'Enterprise Service Agreement', labelKey: 'agreement.tabEnterprise' },
  ],
  logoDisplay: {
    mode: 'image',
    image: juxflowLogo,
    imageStyle: { height: '28px' },
    showGlow: true,
  },
  // 该域名默认英文
  defaultLanguage: 'en-US',
  // 未登录时隐藏侧边栏底部「登录/注册」按钮
  showLoginRegisterButton: false,
  // 隐藏侧边栏「视频剪辑」入口
  hiddenSidebarItems: ['videoEdit'],
  // 开发/测试环境展示右下角「品牌模拟」按钮，便于一键切回
  showBrandDebugSwitch: true,
};
